// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2441":"4d32df9069bce511","8260":"67c030524d1850e3"}[chunkId] + ".css";
};